import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }

import Layout from '@/app/components/Layout.vue'
import PageTitle from '@/app/components/header/PageTitle.vue'
import HeaderRoot from '@/app/components/header/Root.vue'

/**
 * A basic layout with a header.
 *
 * It's the default layout for root level pages, such as the Discover and My Library pages.
 *
 * @param title - The title of the page. It's used in the desktop header and, if no `mobileTitle` is provided, in the mobile header too.
 * @param mobileTitle - A shorter title to be displayed in the mobile header.
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'RootPageLayout',
  props: {
    title: {},
    subtitle: {},
    mobileTitle: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, { class: "layout--basic" }, {
    default: _withCtx(() => [
      _createVNode(HeaderRoot, {
        title: __props.mobileTitle ? __props.mobileTitle : __props.title,
        subtitle: __props.subtitle
      }, {
        actions: _withCtx(() => [
          _renderSlot(_ctx.$slots, "actions")
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "header")
        ]),
        _: 3
      }, 8, ["title", "subtitle"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PageTitle, { title: __props.title }, {
          actions: _withCtx(() => [
            _renderSlot(_ctx.$slots, "actions")
          ]),
          _: 3
        }, 8, ["title"]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }))
}
}

})